import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Logo from "../assets/icons/Logo";
import Login from "../assets/icons/Login";
import ArrowDown from "../assets/icons/ArrowDown";
import Email from "../assets/icons/Email";
import OtpInput from "react-otp-input";
import { ToastContainer, toast } from "react-toastify";
import Google from "../assets/icons/Google";
import adminImg from "../assets/images/admin-img.png";
import Modal from "./Modal";
import EyeHide from "../assets/icons/EyeHide";
import Eye from "../assets/icons/Eye";
import { post } from "../network/api";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";
import {
  storeLoginData,
  getLoginData,
  removeLoginData,
  isLoggedIn,
} from "../utils/loginSession";
import LanguageSwitcher from "../../src/components/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email ID is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  terms: Yup.boolean().oneOf(
    [true],
    "You must accept the terms and conditions"
  ),
});
const signInValidateSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email ID is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
});

const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isCreateAccountModalOpen, setCreateAccountModalOpen] = useState(false);
  const [isCreateAccountOTPModalOpen, setCreateAccountOTPModalOpen] =
    useState(false);
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});

  const dropdownRef = useRef(null);
  const location = useLocation();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const user = getLoginData()?.user;

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  const toggleLoginModal = () => {
    setLoginModalOpen(!isLoginModalOpen);
  };

  const toggleCreateAccountModal = () => {
    setCreateAccountModalOpen(!isCreateAccountModalOpen);
  };

  const switchToCreateAccountModal = () => {
    setLoginModalOpen(false);
    setCreateAccountModalOpen(true);
  };

  const switchToLoginModal = () => {
    setCreateAccountModalOpen(false);
    setLoginModalOpen(true);
  };
  const handleLogout = (event) => {
    event.preventDefault();
    removeLoginData(); // Clear session or token
    navigate("/"); // Redirect to login or another page
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    setDropdownOpen(false);
    setNavOpen(false);
    setLoginModalOpen(false);
    setCreateAccountModalOpen(false);
  }, [location]);

  const navLinks = [
    { name: t("home"), path: "/" },
    { name: t("add_restaurant"), path: "/add-restaurant" },
    { name: t("delivery_partner"), path: "/delivery-partner" },
    ...(user ? [{ name: t("account"), path: "/account/wallet" }] : []),
    // { name: t('account'), path: "/account/wallet" },
    { name: t("contact_us"), path: "/contact" },
  ];

  async function handleLogin(data) {
    try {
      setLoading(true);
      var data = await post("customer/login", {
        email: data.email,
        password: data.password,
        login_type: "email",
      });

      storeLoginData(data);
      setLoading(false);
      window.location.reload();
    } catch (e) {
      setLoading(false);
      // show error alert
    }
  }

  async function sendOTP(data) {
    try {
      setLoading(true);
      setUserData(data);
      var data = await post("customer/send-otp", {
        email: data.email,
        // "password": data.password,
        // "login_type":"email"
      });

      // storeLoginData(data)

      // toast.success("OTP sent successfully!", {
      //   position: "bottom-center",
      //   autoClose: 3000,
      // });
      setLoading(false);
      setCreateAccountOTPModalOpen(true);
    } catch (e) {
      setLoading(false);
      toast.error(e.message, {
        position: "bottom-center",
        autoClose: 3000,
      });
      // setLoading(false)
    }
  }
  async function verifyOTP(data) {
    try {
      setLoading(true);
      var data = await post("customer/signup", {
        email: userData.email,

        // "password": data.password,
        // "login_type":"email"
        full_name: userData.fullName,

        password: userData.password,
        login_type: "email",
        otp: otp,
      });

      storeLoginData(data);
      setLoading(false);
      window.location.reload();

      toast.success("Account created!", {
        position: "bottom-center",
        autoClose: 3000,
      });
    } catch (e) {
      setLoading(false);
      toast.error(e.message, {
        position: "bottom-center",
        autoClose: 3000,
      });
      // setLoading(false)
    }
  }
  const [otp, setOtp] = useState("");

  return (
    <>
      <ToastContainer />
      {isLoading && <Loader />}
      <header className="hr_header">
        <div className="wrapper">
          <div className="hr_spacing">
            <Link to="/" className="logo">
              <Logo />
            </Link>

            <nav className={`hr_navigation ${isNavOpen ? "active_nav" : ""}`}>
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`${
                    location.pathname === link.path
                      ? "link active_link"
                      : "link"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            <LanguageSwitcher></LanguageSwitcher>

            <div className="auth_flex">
              {!user && (
                <div className="auth_login" onClick={toggleLoginModal}>
                  <Login />
                  <span>{t("login_signup")}</span>
                </div>
              )}

              {user && (
                <div className="menu_relative" ref={dropdownRef}>
                  <div className="menu_avatar" onClick={toggleDropdown}>
                    <img src={adminImg} alt="User Avatar" />
                    {user && <span>{user.full_name}</span>}

                    <ArrowDown />
                  </div>

                  {isDropdownOpen && (
                    <div className="menu_absolute">
                      <Link to="/account/profile" className="menu_lks">
                        Profile
                      </Link>
                      <Link to="/account/profile" className="menu_lks">
                        Settings
                      </Link>
                      <a href="#" onClick={handleLogout} className="menu_lks">
                        Logout
                      </a>
                      {/* <Link to="/logout" className="menu_lks">
                    Logout
                  </Link> */}
                    </div>
                  )}
                </div>
              )}

              <div
                className={`${!isNavOpen ? "hamburger" : "hamburger active"}`}
                onClick={toggleNav}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Login Modal */}
      <Modal
        show={isLoginModalOpen}
        onClose={() => setLoginModalOpen(false)}
        size={"md"}
      >
        <div className="login_main-header">
          <h1>Welcome!</h1>
          <p>Please sign in to continue and make the most of our platform.</p>
        </div>
        <div className="login_main-body">
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={signInValidateSchema}
            onSubmit={(values) => {
              
              handleLogin(values);
            }}
          >
            <Form>
              <div className="input_group">
                <label htmlFor="email-id" className="input_label">
                  Email ID
                </label>
                <Field
                  type="email"
                  id="email-id"
                  name="email"
                  className="login_input"
                  placeholder="Enter your email ID"
                />
                <ErrorMessage name="email" component="div" className="error" />
              </div>

              <div className="input_group pos_relative">
                <label htmlFor="password" className="input_label">
                  Password
                </label>
                <Field
                  type={isPasswordVisible ? "text" : "password"}
                  id="password"
                  name="password"
                  className="login_input"
                  placeholder="Enter your password"
                />
                <div
                  className="eye_absolute"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? <EyeHide /> : <Eye />}
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="error"
                />
              </div>

              <button type="submit" className="login_main-btn">
                Login
              </button>
            </Form>
          </Formik>
          {/* <div className="login_main-or-separator">
            <span>OR</span>
          </div>
          <div className="auth_buttons">
            <button className="login_main">
              <Email />
              <span>Continue with email</span>
            </button>
            <button className="login_main">
              <Google />
              <span>Continue with Google</span>
            </button>
          </div> */}
          <div className="auth_buttons_spacer"></div>
        </div>
        <div className="login_main-footer">
          <p>
            Don’t Have An Account?{" "}
            <a href="#" onClick={switchToCreateAccountModal}>
              Create New Account
            </a>
          </p>
        </div>
      </Modal>

      {/* Create Account Modal */}
      <Modal
        show={isCreateAccountModalOpen}
        onClose={() => setCreateAccountModalOpen(false)}
        size={"md"}
      >
        <div className="login_main-header">
          <h1>Get Started!</h1>
          <p>
            Join us today and experience the best in food delivery services.
          </p>
        </div>
        <div className="login_main-body">
          <Formik
            initialValues={{
              fullName: "",
              email: "",
              password: "",
              confirmPassword: "",
              terms: false,
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              sendOTP(values);
            }}
          >
            {({ values }) => (
              <Form>
                <div className="input_group">
                  <label htmlFor="full-name" className="input_label">
                    Full Name
                  </label>
                  <Field
                    type="text"
                    id="full-name"
                    name="fullName"
                    className="login_input"
                    placeholder="Enter your full name"
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="input_group">
                  <label htmlFor="email-id" className="input_label">
                    Email ID
                  </label>
                  <Field
                    type="email"
                    id="email-id"
                    name="email"
                    className="login_input"
                    placeholder="Enter your email ID"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="input_group pos_relative">
                  <label htmlFor="s_password" className="input_label">
                    Password
                  </label>
                  <Field
                    type={isPasswordVisible ? "text" : "password"}
                    id="s_password"
                    name="password"
                    className="login_input"
                    placeholder="Enter your password"
                  />
                  <div
                    className="eye_absolute"
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? <EyeHide /> : <Eye />}
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="input_group pos_relative">
                  <label htmlFor="c_password" className="input_label">
                    Confirm Password
                  </label>
                  <Field
                    type={isConfirmPasswordVisible ? "text" : "password"}
                    id="c_password"
                    name="confirmPassword"
                    className="login_input"
                    placeholder="Enter your password"
                  />
                  <div
                    className="eye_absolute"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {isConfirmPasswordVisible ? <EyeHide /> : <Eye />}
                  </div>
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="error"
                  />
                </div>

                {/* <div className="m_checbox">
                  <div className="checkbox_container">
                    <Field type="checkbox" id="terms-checkbox" name="terms" />
                    <label htmlFor="terms-checkbox">
                      I agree to the{" "}
                      <a href="#">
                        terms and conditions
                      </a>{" "}
                      
                    </label>
                  </div>
                  <ErrorMessage
                    name="terms"
                    component="div"
                    className="error"
                  />
                </div> */}
<div className="m_checbox">
  <div className="checkbox_container">
    <Field type="checkbox" id="terms-checkbox" name="terms" />
    <label htmlFor="terms-checkbox">
      I agree to the{" "}
      <a href="https://loadinn.lv/terms">terms and conditions </a>
      and 
      <a href="https://loadinn.lv/privacy-policy"> privacy policy</a>
    </label>
  </div>
  <ErrorMessage
    name="terms"
    component="div"
    className="error"
  />
</div>


                <button
                  type="submit"
                  className="login_main-btn"
                  // onClick={async () => {
                  //   console.log(values);
                    
                    
                  // }}
                >
                  Create Account
                </button>
              </Form>
            )}
          </Formik>
          {/* <div className="login_main-or-separator">
            <span>OR</span>
          </div> */}
          {/* <div className="auth_buttons">
            <button className="login_main">
              <Google />
              <span>Continue with Google</span>
            </button>
          </div> */}
          <div className="auth_buttons_spacer"></div>
        </div>
        <div className="login_main-footer">
          <p>
            Already Have An Account?{" "}
            <a href="#" onClick={switchToLoginModal}>
              Sign In
            </a>
          </p>
        </div>
      </Modal>
      {/* Create Account Modal */}

      {/* OTP Modal */}
      <Modal
        show={isCreateAccountOTPModalOpen}
        onClose={() => setCreateAccountOTPModalOpen(false)}
        size={"md"}
      >
        <div className="login_main-header">
          <h1>Verify with OTP</h1>
          <p>Enter the OTP to complete your verification process.</p>
        </div>
        <div className="login_main-body">
          <Formik
            initialValues={{
              otp: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ values }) => {
              // Function to handle numeric-only input
              const handleOtpChange = (value) => {
                // Only allow numeric characters
                const numericValue = value.replace(/[^0-9]/g, "");
                // Limit to 6 digits
                // const limitedValue = numericValue.slice(0, 6);
                setOtp(numericValue);
              };
              return (
                <Form>
                  <div className="pb-4">
                    <OtpInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                      inputStyle={{
                        width: "100%",
                        maxWidth: "3rem",
                        height: "3rem",
                        margin: "0 0.25rem",
                        fontSize: "1.25rem",
                        borderRadius: "8px",
                        border: "2px solid #e5e7eb",
                        textAlign: "center",
                        outline: "none",
                        transition: "all 0.2s",
                      }}
                      focusStyle={{
                        border: "2px solid #3b82f6",
                        outline: "none",
                      }}
                      shouldAutoFocus={true}
                      // inputType="number"
                      containerStyle={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    />
                  </div>

                  <button
                    type="submit"
                    className="login_main-btn"
                    onClick={() => {
                      verifyOTP(values);
                    }}
                  >
                    Submit One Time Password
                  </button>
                </Form>
              );
            }}
          </Formik>
          {/* <div className="login_main-or-separator">
            <span>OR</span>
          </div>
          <div className="auth_buttons">
            <button className="login_main">
              <Google />
              <span>Continue with Google</span>
            </button>
          </div> */}
        </div>
        <div className="login_main-footer pt-4">
          <p>
            Didn’t Received Code?{" "}
            <a
              href="#"
              className="!text-[#D91D1E] !no-underline"
              onClick={switchToLoginModal}
            >
              Resend
            </a>
          </p>
        </div>
      </Modal>
      {/* OTP Modal */}
    </>
  );
};

export default Header;
